module.exports = __webpack_public_path__ + "img/thumb_07.792e04d9.jpg";